
            import "data:text/css,.m-offlineIcon-feebb278e0%7Bwidth:24px;height:24px%7D";
            const result = {"offlineIcon":"m-offlineIcon-feebb278e0"};
            export default result;
          